module.exports = __webpack_public_path__ + "static/media/6299.7ba9d943.svg";